
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/installation",
      function () {
        return require("private-next-pages/installation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/installation"])
      });
    }
  